export default {
  state: {
    continueReadingEbookModal: false,
    startEbookModal: false,
    signInUpEbookModal: false,
    windowStateChanged: false
  },
  mutations: {
    setContinueReadingEbookModal (state, payload) {
      state.continueReadingEbookModal = payload
    },
    setSignInUpModal (state, payload) {
      state.signInUpEbookModal = payload
    },
    setStartEbookModal (state, payload) {
      state.startEbookModal = payload
    },
    setWindowStateChanged (state, payload) {
      state.windowStateChanged = payload
    }
  },
  actions: {
    closeContinueReadingEbookModal ({ commit, state }) {
      commit('setContinueReadingEbookModal', false)
      if (state.windowStateChanged) {
        window.history.back()
        commit('setWindowStateChanged', false)
      }
    },
    closeSignInUpModal ({ commit, state }) {
      commit('setSignInUpModal', false)
      if (state.windowStateChanged) {
        window.history.back()
        commit('setWindowStateChanged', false)
      }
    },
    closeStartEbookModal ({ commit, state }) {
      commit('setStartEbookModal', false)
      if (state.windowStateChanged) {
        window.history.back()
        commit('setWindowStateChanged', false)
      }
    },
    openEbookModal ({ commit, rootState }, payload) {
      commit('setEbook', payload.ebook)
      if (rootState.user) {
        if (payload.ebook.isRead) {
          commit('setContinueReadingEbookModal', true)
        } else {
          commit('setStartEbookModal', true)
        }
      } else {
        commit('setSignInUpModal', true)
      }
      if (payload.ebook.ebookCode) {
        window.history.pushState(null, '', `/#/ebook/${payload.ebook.ebookCode}`)
        commit('setWindowStateChanged', true)
      }
    },
    openSignInUpModal ({ commit }) {
      commit('setSignInUpModal', true)
    }
  },
  getters: {
    isContinueReadingEbookModal (state) {
      return state.continueReadingEbookModal
    },
    isSignInUpModal (state) {
      return state.signInUpEbookModal
    },
    isStartEbookModal (state) {
      return state.startEbookModal
    }
  }
}
